import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { depositKeys, invoiceKeys } from '@/lib/queryKeys';
import { billingV2Endpoints } from '@/lib/api/endpoints';
import { billingV2Post } from '@/lib/api/clients/billing-v2';
import type { ApplyDepositInput, ApplyDepositResponse } from '@/types/deposit';

interface ApplyArgs extends ApplyDepositInput {
  depositId: string;
}

/** Spec §4.3 — apply (part of) a deposit to an invoice. */
export function useApplyDeposit() {
  const queryClient = useQueryClient();

  return useApiMutation<ApplyDepositResponse, ApplyArgs>({
    mutationFn: ({ depositId, ...body }) =>
      billingV2Post<ApplyDepositResponse, ApplyDepositInput>(
        billingV2Endpoints.depositApply(depositId),
        body,
      ),
    onSuccess: (data) => {
      queryClient.setQueryData(depositKeys.detail(data.deposit.id), data.deposit);
      void queryClient.invalidateQueries({ queryKey: depositKeys.all() });
      void queryClient.invalidateQueries({ queryKey: invoiceKeys.all() });
      toast.success(`Applied $${Number(data.application.amount).toFixed(2)} from deposit`);
    },
  });
}
